import React, {FC, useRef, useEffect} from "react"
import './Input.less'

interface Props {
    id: string
    label: string
    value: string
    placeholder: string
    autoFocus?: boolean
    autoSelect?: boolean
    withoutHeader?: boolean
    saveOnBlur?: boolean
    disabled?: boolean
    setValue: (value: string) => void
    onConfirm: () => void
    onCancel: () => void
}

export const Input: FC<Props> = ({
                                     id,
                                     label,
                                     value,
                                     autoFocus,
                                     autoSelect,
                                     withoutHeader,
                                     saveOnBlur,
                                     placeholder,
                                     disabled,
                                     setValue,
                                     onConfirm,
                                     onCancel,
                                 }) => {
    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (autoSelect && inputRef.current) {
            // Select all text when autoSelect is true
            inputRef.current.select()
        }
    }, [autoSelect])

    const handleChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value)
    }
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Escape') {
            onCancel()
        } else if (e.key === 'Enter' || e.key === 'NumpadEnter') {
            onConfirm()
        }
    }
    const handleBlur = () => {
        if (saveOnBlur) {
            onConfirm()
        }
    }

    return (
        <div className="form-input-container">
            {!withoutHeader && <label htmlFor={id} className="label">{label}:</label>}
            <input
                id={id}
                type="text"
                className={"input" + (disabled ? ' disabled' : '')}
                value={value || ''}
                placeholder={placeholder}
                onChange={handleChangeValue}
                onKeyDown={handleKeyDown}
                autoFocus={autoFocus}
                disabled={disabled}
                onBlur={handleBlur}
                ref={inputRef}
            />
        </div>
    )
}
